// src/pages/projects/components/TransactionIcons.jsx
import React from 'react';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

/**
 * Icon for income transactions
 */
export const IncomeIcon = (props) => <ArrowUpward {...props} />;

/**
 * Icon for expense transactions
 */
export const ExpenseIcon = (props) => <ArrowDownward {...props} />;